import {useState} from 'react';
import {api} from "../services/Api/api";
import {useNavigate} from "react-router-dom";
import AppConfig from "../services/AppConfig";
import {usePrefix} from "../services/Prefix";
import {useCart} from "../services/Cart/cartService";
import VoucherUtils from "../services/User/VoucherUtils";

interface Props {
	menuItems: any[];
	handleOpenItemsModal: () => void;
	menus: any[];
	categories: any[];
	cart: any;
	userVouchers: any[];
	onRemovePromotion?: () => Promise<void> | void;
	externalPromotionId?: number;
}

export const useVoucherProducts = ({ menuItems, handleOpenItemsModal, menus, categories, cart, userVouchers, onRemovePromotion, externalPromotionId }: Props) => {
	const navigate = useNavigate();
	const prefix = usePrefix();
	const [promotionItems, setPromotionItems] = useState<any[]>([]);
	const cartService = useCart();
	const [promotion, setPromotion] = useState<any>();
	const vouchers = VoucherUtils.getVoucherWithCarts(userVouchers, cart);

	const fetchPromotion = async (promotionId?: string) => {
		if (!promotionId) return;

		try {
			const res = await api.getPromotion(promotionId);
			setPromotion(res);
			return res;
		}
		catch (error) {}
	}

	const findMenuForPromotionItem = (promotionItem: any) => {
		const itemCategory = categories.find(category => category.entities.map((entity: any) => entity.entity_id).includes(promotionItem.id));

		if (!itemCategory) return undefined;

		return menus.find(menu => {
			const category = menu.categories.find((menuCategory: any) => menuCategory.category_id === itemCategory.id);

			if(category) return menu.id;

			return undefined;
		})?.id;
	}

	const findPromotionItemsInMenu = (promotionItems: any[]) => {
		const promotionItemsIds = promotionItems.map(item => item.entity_id);

		return menuItems.filter(menuItem => {
			return promotionItemsIds.includes(menuItem.id);
		})
	}

	const handlePromotionChange = async (promotionId?: string) => {
		const promotion = await fetchPromotion(promotionId);

		if(!promotion) return;

		const promotionItems = findPromotionItemsInMenu(promotion.entities.filter((entity: any) => entity.type === "ITEM"));
		setPromotionItems(promotionItems)

		if(promotionItems.length === 1) {
			const menuId = findMenuForPromotionItem(promotionItems[0]);

			if(menuId) {
				navigate(AppConfig.getLinkWithPrefix(`/menu/${menuId}/add/${promotionItems[0].id}`, prefix), {state: {back: true, promotionId: promotion.id}});
			}

		}
		else if(promotionItems.length > 1) {
			handleOpenItemsModal();
		}
	}

	const handleRemovePromotion = async () => {
		setPromotion(undefined);
		if (onRemovePromotion) await onRemovePromotion();

		const finalPromotionId = externalPromotionId ?? promotion.id;
		const promotionToRemove = cart.promotions.find((cartPromotion: any) => cartPromotion.promotion_id === finalPromotionId);

		if (promotionToRemove) {
			await cartService.removePromotion(promotionToRemove.id);
		}
		else {
			const voucherToRemove =  cart.promotions.find((cartPromotion: any) => vouchers.find(voucher => voucher.voucher?.id === cartPromotion.reference_id));

			if (voucherToRemove) {
				await cartService.removePromotion(voucherToRemove.id);
			}
		}
	}

	return {
		handlePromotionChange,
		findMenuForPromotionItem,
		promotionItems,
		handleRemovePromotion
	};
}